const ArrowRightBig = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 40 40"
            {...props}
        >
            <g
                id="Group_27"
                data-name="Group 27"
                transform="translate(-2293.458 -327.458)"
            >
                <rect
                    id="Rectangle_4"
                    data-name="Rectangle 4"
                    width={40}
                    height={40}
                    transform="translate(2293.458 327.458)"
                    fill="#fff"
                    opacity={0}
                />
                <g
                    id="Group_10"
                    data-name="Group 10"
                    transform="translate(2249.112 311.638) rotate(45)"
                >
                    <path
                        id="Path_11"
                        data-name="Path 11"
                        d="M285.378,195.46a.595.595,0,0,0-.6-.6h-.005q-5.519.045-10.72.048c-4.075.012-7.925.021-11.731.063a.6.6,0,0,0-.587.589l-.006.688-.013,1.377a.547.547,0,0,0,.013.125.593.593,0,0,0,.581.475h0l5.971-.027,8.4-.04,3.139-.015-17.484,17.484a.825.825,0,0,0,0,1.166l1.1,1.1a.824.824,0,0,0,1.166,0L282.1,200.407l-.016,3.138c-.013,2.594-.026,5.452-.04,8.406l-.027,5.971a.591.591,0,0,0,.176.423.584.584,0,0,0,.3.16.482.482,0,0,0,.117.013h.006l1.27-.013.8-.008a.6.6,0,0,0,.589-.586c.041-3.807.052-7.656.062-11.731q.008-2.6.017-5.279T285.378,195.46Z"
                        transform="translate(-202.72 -226.86)"
                        fill="#fff"
                    />
                </g>
            </g>
        </svg>
    )
}

export default ArrowRightBig
